/**
 * 多语言国际化常量定义
 */

/**
 * 支持的语言代码
 */
export const SUPPORTED_LANGUAGES = {
  ZH_CN: 'zh-CN',
  EN_US: 'en-US',
  PT_BR: 'pt-BR',
} as const

export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[keyof typeof SUPPORTED_LANGUAGES]

/**
 * 语言显示名称映射
 */
export const LANGUAGE_DISPLAY_NAMES: Record<SupportedLanguage, { native: string; english: string }> = {
  [SUPPORTED_LANGUAGES.ZH_CN]: {
    native: '简体中文',
    english: 'Chinese (Simplified)',
  },
  [SUPPORTED_LANGUAGES.EN_US]: {
    native: 'English',
    english: 'English',
  },
  [SUPPORTED_LANGUAGES.PT_BR]: {
    native: 'Português',
    english: 'Portuguese (Brazil)',
  },
}

/**
 * 语言本地存储键名
 */
export const LANGUAGE_STORAGE_KEY = 'language'

/**
 * 默认语言
 */
export const DEFAULT_LANGUAGE = SUPPORTED_LANGUAGES.ZH_CN

/**
 * 命名空间常量
 */
export const NAMESPACES = {
  COMMON: 'common',
  PAGES: 'pages',
  MODULES: 'modules',
  COMPONENTS: 'components',
  ERRORS: 'errors',
  VALIDATION: 'validation',
} as const

export type Namespace = typeof NAMESPACES[keyof typeof NAMESPACES]

/**
 * 默认命名空间
 */
export const DEFAULT_NAMESPACE = NAMESPACES.COMMON

/**
 * Ant Design 语言包映射
 */
export const ANT_D_LOCALE_MAP: Record<SupportedLanguage, string> = {
  [SUPPORTED_LANGUAGES.ZH_CN]: 'zhCN',
  [SUPPORTED_LANGUAGES.EN_US]: 'enUS',
  [SUPPORTED_LANGUAGES.PT_BR]: 'enUS', // 葡萄牙语使用英文作为回退
}

/**
 * 语言检测顺序
 */
export const LANGUAGE_DETECTION_ORDER = ['localStorage', 'navigator'] as const

/**
 * 语言缓存方式
 */
export const LANGUAGE_CACHES = ['localStorage'] as const